export default __webpack_public_path__ + "static/media/P7000.456dc1e9.jpg";